import create from 'zustand';

import { AudioObject } from 'hooks/useElevenLabsAudio';

export type VoiceOver = Array<AudioObject>;

interface VoiceOverState {
  audioChunks?: VoiceOver;
  setAudioChunks: (voiceOver: VoiceOver) => void;

  isPlaying: boolean;
  setIsPlaying: (isPlaying: boolean) => void;
  toggleIsPlaying: () => void;

  currentStep: number;
  setCurrentStep: (index: number) => void;

  currentAudioDuration: number;
  setCurrentAudioDuration: (duration: number) => void;
}

const useAudioRoutingStore = create<VoiceOverState>(set => ({
  audioChunks: undefined,
  setAudioChunks: voiceOver => set({ audioChunks: voiceOver }),

  isPlaying: false,
  setIsPlaying: (isPlaying: boolean) => set({ isPlaying }),
  toggleIsPlaying: () => set(state => ({ isPlaying: !state.isPlaying })),

  currentStep: 0,
  setCurrentStep: (index: number) => set({ currentStep: index }),

  currentAudioDuration: 0,
  setCurrentAudioDuration: (duration: number) =>
    set({ currentAudioDuration: duration }),
}));

export default useAudioRoutingStore;
